import { PERMISSIONS, PermissionChecker } from '../auth/permissions';

export type ToolId = 'project_acceptance' | 'inspection';

export interface Tool {
  readonly id: ToolId;
  readonly name: string;
  readonly description: string;
  readonly icon: string;
  readonly accessPermission: string;
  readonly homePath: string;
}

export const PROJECT_ACCEPTANCE_TOOL = {
  id: 'project_acceptance',
  name: 'Project Acceptance',
  description:
    'Submit construction intake requests, review quality scorecards, and manage project acceptance cases.',
  icon: 'photo_library',
  accessPermission: PERMISSIONS.PROJECT_ACCEPTANCE_ACCESS,
  homePath: '/dashboard',
} as const satisfies Tool;

export const INSPECTION_TOOL = {
  id: 'inspection',
  name: 'On-site Inspection',
  description:
    'Record on-site construction quality inspections, checklist findings, and escalations.',
  icon: 'fact_check',
  accessPermission: PERMISSIONS.INSPECTION_ACCESS,
  homePath: '/inspections',
} as const satisfies Tool;

export const TOOLS: readonly Tool[] = [PROJECT_ACCEPTANCE_TOOL, INSPECTION_TOOL];

function normalizePathname(url: string): string {
  const withoutQueryOrHash = url.split(/[?#]/)[0] || '/';
  return withoutQueryOrHash.startsWith('/') ? withoutQueryOrHash : `/${withoutQueryOrHash}`;
}

export function getAccessibleTools(
  checker: PermissionChecker,
  tools: readonly Tool[] = TOOLS,
): Tool[] {
  return tools.filter((tool) => checker.hasPermission(tool.accessPermission));
}

export function resolveToolFromUrl(url: string, tools: readonly Tool[] = TOOLS): Tool {
  const pathname = normalizePathname(url);
  const matchedTool = tools.find(
    (tool) =>
      tool.id !== PROJECT_ACCEPTANCE_TOOL.id &&
      (pathname === tool.homePath || pathname.startsWith(`${tool.homePath}/`)),
  );
  return matchedTool ?? PROJECT_ACCEPTANCE_TOOL;
}
